var map = {
	"./card.png": 3393,
	"./close-icon.png": 3398,
	"./img1.png": 3142,
	"./img10.png": 4874,
	"./img11.png": 8738,
	"./img2.png": 9598,
	"./img3.png": 3146,
	"./img4.png": 3818,
	"./img5.png": 8155,
	"./img6.png": 4771,
	"./img7.png": 205,
	"./img8.png": 5621,
	"./img9.png": 8643,
	"./intro.png": 7273,
	"./logo.png": 6949,
	"./mobile-icon.png": 6165,
	"./pk-logo.png": 323,
	"./right-icon.png": 4238,
	"./tap-icon.png": 5201,
	"./title-icon.png": 4263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;